import React from 'react';
import { Redirect } from 'react-router-dom';

const Home = () => {
	return <Redirect to="/admin/shop/products" />
}

export default Home;